module.exports = __webpack_public_path__ + "static/img/421423275.d796cf2c.png";